import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    input,
    OnDestroy,
    output
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimaryButtonComponent } from '@tran-monorepo/frontend/components';
import { HeaderScrollService } from '../../../services/header-scroll.service';
import { ContentSectionComponent } from '../content-section/content-section.component';

@Component({
    selector: 'tran-page-hero',
    imports: [TranslatePipe, ContentSectionComponent, PrimaryButtonComponent],
    templateUrl: './page-hero.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeroComponent implements AfterViewInit, OnDestroy {
    private readonly elementRef = inject(ElementRef);
    private readonly headerScrollService = inject(HeaderScrollService);

    public readonly backgroundImage = input<string>();
    public readonly eyebrow = input<string>();
    public readonly titleKey = input<string>();
    public readonly description = input<string>();
    public readonly ctaLabel = input<string>();
    public readonly ctaLink = input<string>();
    public readonly ctaClicked = output<void>();
    public readonly showOverlay = input<boolean>(true);
    public readonly backgroundPosition = input<string>('center center');

    ngAfterViewInit(): void {
        this.headerScrollService.registerHeroElement(this.elementRef.nativeElement);
    }

    ngOnDestroy(): void {
        this.headerScrollService.unregisterHeroElement();
    }
}
